import type { MyChallenge } from '@accra/shared';
import { PLAYER_VEHICLES, type PlayerVehicleId } from '../../content/playerVehicles';
import { routeById } from '../../content/routes';
import { ago } from '../../ui/components/timeAgo';
import { el } from '../components/el';

/** The challenges you've sent, with each friend's best try. New tries are highlighted; 🏆 marks the ones that beat you. */
export function challengesView(challenges: MyChallenge[] | null, copy: (code: string) => Promise<'copied' | 'failed'>): HTMLElement {
  const wrap = el('div', 'me-view');
  if (challenges === null) {
    wrap.append(el('p', 'empty', 'Offline: your challenges need a connection.'));
    return wrap;
  }
  if (challenges.length === 0) {
    wrap.append(el('p', 'empty', 'You have not challenged anyone yet. Finish a shift and press “Challenge a friend”.'));
    return wrap;
  }
  const list = el('div', 'challenge-list');
  for (const challenge of challenges) {
    const card = el('article', 'challenge-card');
    const road = challenge.route ? routeById(challenge.route).name : 'Your road';
    const vehicle = PLAYER_VEHICLES[challenge.vehicle as PlayerVehicleId]?.name ?? challenge.vehicle;
    const head = el('div', 'challenge-head');
    const title = el('div', 'challenge-title');
    title.append(el('b', '', `${challenge.score.toLocaleString()} points`), el('small', 'muted', `${road} · ${vehicle} · ${ago(challenge.createdAt)}`));
    const copyBtn = el('button', 'btn small', 'Copy link');
    copyBtn.addEventListener('click', () => {
      void copy(challenge.code).then((result) => {
        copyBtn.textContent = result === 'copied' ? '✓ Copied' : 'Could not copy';
        window.setTimeout(() => (copyBtn.textContent = 'Copy link'), 2000);
      });
    });
    head.append(title, copyBtn);
    card.append(head);
    if (challenge.attempts.length === 0) card.append(el('small', 'muted', 'Nobody has tried it yet.'));
    for (const attempt of challenge.attempts) {
      const row = el('div', attempt.isNew ? 'attempt new' : 'attempt');
      row.append(
        el('span', 'attempt-name', attempt.name),
        el('span', 'attempt-score', attempt.score.toLocaleString()),
        el('span', 'attempt-note', attempt.beaten ? '🏆 beat you' : 'you lead'),
        attempt.isNew ? el('span', 'attempt-new', 'NEW') : el('span'),
      );
      card.append(row);
    }
    list.append(card);
  }
  wrap.append(list);
  return wrap;
}
